export enum TodoCategory {
    PACKAGES_TO_SIGN = "PackageToSign",
    DOCUMENTS_TO_SIGN = "DocumentToSign",
    CUSTOMER_CARD = "CustomerCard",
    COMMUNICATION_SALARY = "CommunicationSalary",
    LIABILITY = "Liability10",
    TARIFFICATION = "Tariffication",
    DATA_VERIFICATION = "MoralForm",
}

export type Todo = MyBrokerApi.ToDo;
